import LayoutSlider from './LayoutSlider';
export default LayoutSlider;
